module.exports = __webpack_public_path__ + "img/mouth-06.e9367707.svg";